<b-modal v-model="modal_requirement_172" :size="modalSize" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <!-- ダイアログヘッダ-->
  <template v-slot:header>
    <div class="text-center w-100">{{ headerTitle }}</div>
  </template>

  <!-- ダイアログボディ-->
  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid">
        <!-- テキストメッセージ表示 -->
        <div v-if="workSupportMessage" class="w-100">
          <div class="box-margin-right work-support-message">
            {{ workSupportMessage }}
          </div>
        </div>
        <template v-if="showCustomTable">
          <!-- ファイルエクスポートボタン-->
          <div class="row mt-2 ml-1">
            <b-button size="sm" variant="primary" :disabled="isLoading" @click="csvExport" class="mx-2">
              {{ $t('message.file_export') }}
            </b-button>
          </div>
          <!-- データ表示テーブル -->
          <div class="flexible-container">
            <custom-table useStripeStyle hasTabs :items="tableItems" :columns="tableColumns"
              :currentSortkey="currentSortKey" initSortDir="asc" useSort class="mt-2 ml-2" type="simple">
            </custom-table>
          </div>
        </template>
        <!-- プロジェクトデータ保存 -->
        <div class="flexible-container">
          <project-data v-if="showProjectData" ref="projectData" :vin="vin" :vehicleName="vehicleName"
            :displayProjectID="displayProjectID" :registrationNumber="registrationNumber" :functionName="functionName"
            :dataName="dataName" :memo="memo" :hideRegistrationNumber="hideRegistrationNumber"
            :diagnoseComment="diagnoseComment">
          </project-data>
        </div>
      </div>
    </b-overlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center">
      <b-button v-if="showButtonCancel" size="sm" variant="outline-primary" :disabled="isLoading"
        @click="changePhaseToDataDisplay" class="mx-2">
        {{ $t('message.common_button_cancel') }}
      </b-button>
      <b-button v-if="showButtonSave" size="sm" variant="primary" :disabled="isLoading" @click="onSaveClicked"
        class="mx-2">
        {{ $t('message.common_button_save') }}
      </b-button>
      <b-button v-if="showButtonFinish" size="sm" variant="outline-primary" :disabled="isLoading"
        @click="onFinishClicked" class="mx-2">
        {{ $t('individual.label_button_finish') }}
      </b-button>
      <b-button v-if="showButtonOk" size="sm" variant="primary" :disabled="isLoading" @click="closeWizard" class="mx-2">
        {{ $t('message.common_button_ok') }}
      </b-button>
    </div>
  </template>
</b-modal>
